/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsRosterListResponseDtoSchema } from "./goodLuck/core/DTOs/rosterListResponseDtoSchema.ts";
import { z } from "zod/v4";

export const getTeamsQueryParamsSchema = z.object({
  page: z.coerce.number().int().default(1).describe("Номер страницы (с 1)"),
  pageSize: z.coerce
    .number()
    .int()
    .default(20)
    .describe("Размер страницы (1–50, по умолчанию 20)"),
  isLookingForPlayers: z.optional(
    z.boolean().describe("Если true — только команды, ищущие игроков"),
  ),
  search: z.optional(
    z.string().describe("Поиск по названию и тегу команды (KAN-851)"),
  ),
});

/**
 * @description Возвращает список команд
 */
export const getTeams200Schema = z.lazy(
  () => goodLuckCoreDTOsRosterListResponseDtoSchema,
);

export const getTeamsQueryResponseSchema = getTeams200Schema;
